<template>
  <div class='request' v-loading="loading">
    <div class="YTitle">{{data.title}}</div>
    <div class="box">
      <YHead></YHead>

      <YBillTemplate :fromList='fromList' v-if="fromList.length > 0" ref="YBillTemplate"></YBillTemplate>

      <div class="btn">
        <el-button type="primary" round @click="submit">提交</el-button>
        <el-button plain round @click="close">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/shared/api/apps/requisition'
export default {
  name: 'request',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      loading: false,
      flowDefine: {},
      fromList: []
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getFlow()
    },

    getFlow () {
      if (!this.data.id) return
      const params = {
        method: api.defineGet,
        id: this.data.id
      }
      this.loading = true
      this.axios.post(params).then(res => {
        if (res.data.backend_odc_flow_define_get_response.code !== '10000') return
        if (!res.data.backend_odc_flow_define_get_response.result.flowDefine.formId) return
        this.flowDefine = res.data.backend_odc_flow_define_get_response.result
        this.getData(res.data.backend_odc_flow_define_get_response.result.flowDefine.formId)
      })
    },

    getData (val) {
      const params = {
        method: api.formPageGet,
        id: val
      }

      this.axios.post(params).then(res => {
        this.loading = false
        if (res.data.backend_odc_flow_formPage_get_response.code !== '10000') return
        this.fromList = JSON.parse(res.data.backend_odc_flow_formPage_get_response.result.pageConfig)
      })
    },

    submit () {
      this.$refs.YBillTemplate.submitForm().then(res => {
        const params = {
          method: api.flowJobAdd,
          defId: this.data.id,
          formValue: JSON.stringify(res),
          copyInfoes: this.flowDefine.copyInfoes,
          auditInfoes: this.flowDefine.auditInfoes
        }

        this.axios.post(params).then(res => {
          if (res.data.backend_odc_flow_flowJob_add_response.code !== '10000') return
          this.$message({
            message: '工单申请发起成功',
            type: 'success'
          })
          this.close()
        })
      })
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='stylus' scoped>
  .request
    width 100%
    height 100%
    background #ffffff
    display flex
    flex-direction column
    .box
      flex auto
      overflow auto
      .btn
        margin 20px 0
        text-align center
</style>
